import { showToast } from './utils.js';

const STORAGE_KEY = 'mysky_dense';

export function isDenseModeOn() {
  return localStorage.getItem(STORAGE_KEY) === '1';
}

export function applyDensityClass() {
  document.body.classList.toggle('density-compact', isDenseModeOn());
  updateDensityButton();
}

export function updateDensityButton() {
  const btn = document.getElementById('densityToggle');
  if (!btn) return;
  const on = isDenseModeOn();
  btn.classList.toggle('is-on', on);
  btn.setAttribute('aria-pressed', on ? 'true' : 'false');
  btn.title = on ? 'Compact tables on — tap for comfortable spacing' : 'Compact tables — tighter rows';
  btn.setAttribute('aria-label', on ? 'Disable compact tables' : 'Enable compact tables');
}

export function toggleDensity() {
  const on = !isDenseModeOn();
  localStorage.setItem(STORAGE_KEY, on ? '1' : '0');
  applyDensityClass();
  showToast(on ? 'Compact tables on' : 'Comfortable spacing');
}

export function initDensityControls() {
  applyDensityClass();
  const btn = document.getElementById('densityToggle');
  if (!btn || btn.dataset.bound) return;
  btn.dataset.bound = '1';
  btn.addEventListener('click', toggleDensity);
}
